import React, { useEffect, useState } from 'react';

const loadingMessages = [
  "Connexion au serveur...",
  "Initialisation de l'application...",
  "Chargement des modules...",
  "Mise à jour des notifications...",
  "Préparation de votre espace...",
  "Presque prêt !"
];

export default function LoadingScreen({ appName = "PulseCIO" }) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 1800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mb-6"></div>
      <h1 className="text-2xl font-bold mb-2 text-primary">{appName}</h1>
      <div className="text-lg text-gray-700 dark:text-gray-200 animate-pulse">
        {loadingMessages[messageIndex]}
      </div>
    </div>
  );
}
